import React from "react";
import { styled } from "styled-components";
import { Divider } from "antd";

import TitleHeader from "../../components/Common/TitleHeader";
import { USEFUL_WEBSITES } from "./UsefulWebsiteData";

const UsefulWebsite = () => {
  return (
    <>
      <Divider />
      <TitleHeader en="USEFUL WEBSITES" th="เว็บไซต์พันธมิตร" center />
      <UsefullWebsiteContainer>
        {USEFUL_WEBSITES.map((i) => (
          <CardUsefulWebsite key={i.path} href={i.path} target="_blank">
            <Image src={i.image} />
          </CardUsefulWebsite>
        ))}
      </UsefullWebsiteContainer>
      <Divider />
    </>
  );
};

const UsefullWebsiteContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    justify-content: center;
  }
`;

const Image = styled.img`
  width: 100%;
  max-width: 250px;
  height: auto;
`;

const CardUsefulWebsite = styled.a`
  background-color: white;
  border: 1px solid lightgray;
  height: 100px;
  width: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
`;

export default UsefulWebsite;
